import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { FC, HTMLAttributes } from 'react';
import BaseCard from '@/components/BaseCard';
import CardTags from '@/components/BaseCard/CardTags';
import { BlogPostDto } from '@/components/BlogPage/types';
import { Typography } from '@/components/shared/Typography';
import StrapiRichContent from '@/components/StrapiRichContent';
import { useBlogPost } from '@/hooks/blog/useBlogPost';
import { blocksContentToAltText } from '@/lib/blocks-content';
import css from './style.module.scss';
interface Props extends Omit<HTMLAttributes<HTMLAnchorElement>, 'title'> {
  post: BlogPostDto;
  showTags?: boolean;
  setIsCustomCursorVisible?: (value: boolean) => void;
}
const PostCard: FC<Props> = t0 => {
  const $ = _c(37);
  let className;
  let post;
  let rest;
  let setIsCustomCursorVisible;
  let t1;
  if ($[0] !== t0) {
    ({
      post,
      className,
      showTags: t1,
      setIsCustomCursorVisible,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = post;
    $[3] = rest;
    $[4] = setIsCustomCursorVisible;
    $[5] = t1;
  } else {
    className = $[1];
    post = $[2];
    rest = $[3];
    setIsCustomCursorVisible = $[4];
    t1 = $[5];
  }
  const showTags = t1 === undefined ? true : t1;
  const {
    cardTitle,
    media,
    isVideo,
    href
  } = useBlogPost(post);
  const t2 = isVideo ? media?.url : null;
  const t3 = isVideo ? null : media?.url;
  let t4;
  if ($[6] !== cardTitle || $[7] !== media || $[8] !== post.alt) {
    t4 = media && "alternativeText" in media && media.alternativeText || post.alt || blocksContentToAltText(cardTitle);
    $[6] = cardTitle;
    $[7] = media;
    $[8] = post.alt;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = Boolean(setIsCustomCursorVisible) && css.hideDefaultCursor;
  let t6;
  if ($[10] !== className || $[11] !== t5) {
    t6 = clsx(css.postCard, className, t5);
    $[10] = className;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== post.tags || $[14] !== showTags) {
    t7 = showTags ? <CardTags tags={post.tags.map(_temp)} /> : null;
    $[13] = post.tags;
    $[14] = showTags;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== cardTitle) {
    t8 = <h2 className={css.title}><StrapiRichContent content={cardTitle} /></h2>;
    $[16] = cardTitle;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== post.preview) {
    t9 = post.preview?.description ? <Typography variant="body-s" className={css.description}><StrapiRichContent content={post.preview.description} /></Typography> : null;
    $[18] = post.preview;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t8 || $[21] !== t9) {
    t10 = <>{t8}{t9}</>;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  let t12;
  if ($[23] !== setIsCustomCursorVisible) {
    t11 = () => setIsCustomCursorVisible?.(true);
    t12 = () => setIsCustomCursorVisible?.(false);
    $[23] = setIsCustomCursorVisible;
    $[24] = t11;
    $[25] = t12;
  } else {
    t11 = $[24];
    t12 = $[25];
  }
  let t13;
  if ($[26] !== href || $[27] !== rest || $[28] !== t10 || $[29] !== t11 || $[30] !== t12 || $[31] !== t2 || $[32] !== t3 || $[33] !== t4 || $[34] !== t6 || $[35] !== t7) {
    t13 = <BaseCard url={href} videoUrl={t2} imageUrl={t3} mediaClassName={css.media} withOverlay={false} imageAlt={t4} className={t6} tags={t7} mainText={t10} onMouseEnter={t11} onMouseLeave={t12} {...rest} />;
    $[26] = href;
    $[27] = rest;
    $[28] = t10;
    $[29] = t11;
    $[30] = t12;
    $[31] = t2;
    $[32] = t3;
    $[33] = t4;
    $[34] = t6;
    $[35] = t7;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  return t13;
};
export default PostCard;
function _temp(tag) {
  return {
    id: tag.id,
    name: tag.name
  };
}